import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Radios, TextField } from 'mui-rff';
import * as Yup from 'yup';
import { Field } from 'react-final-form';
import { FormPage } from '../../../components/FormPage';
import { FormSection } from '../../../components/FormSection';
import { FormCondition } from '../../../components/FormCondition';
import { DollarFormatInput } from '../../../components/DollarFormatInput/DollarFormatInput';

export function PricePlanFormView({
    app,
    plan,
    loading,
    onSubmit,
    deleting,
    onDelete,
    onCancel,
    disabled,
}: any) {
    if (app === undefined || plan === undefined) {
        return <CircularProgress />;
    }

    const planTypes = [
        { value: 'MONTHLY_CHARGE', label: 'Monthly charge' },
        { value: 'YEARLY_CHARGE', label: 'Yearly charge' },
    ];
    const existingFreePlan = app.pricePlans.find(p => p.type === 'FREE');
    if (existingFreePlan === undefined || existingFreePlan.id.toString() === plan.id.toString()) {
        planTypes.unshift({ value: 'FREE', label: 'Free plan' });
    }

    const breadcrumbs = [
        { label: 'Apps', link: '/extranet/apps' },
        { label: 'Dashboard', link: '/extranet/apps/' + plan.appId + '/dashboard' },
    ];

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required').max(30, 'Max 30 chars'),
        type: Yup.string().required('You must select a type'),
        monthlyAmount: Yup.number().when('type', {
            is: 'MONTHLY_CHARGE',
            then: Yup.number()
                .required('Must enter the monthly amount')
                .moreThan(0, 'Monthly amount must be larger than zero'),
        }),
        yearlyAmount: Yup.number()
            .when('type', {
                is: 'YEARLY_CHARGE',
                then: Yup.number()
                    .required('Must enter the yearly amount')
                    .moreThan(0, 'Yearly amount must be larger than zero'),
            })
            .when(['type', 'discountedYearlyPrice'], {
                is: (type, discountedYearlyPrice) =>
                    type === 'MONTHLY_CHARGE' && discountedYearlyPrice,
                then: Yup.number()
                    .required('Must enter the yearly amount')
                    .moreThan(
                        Yup.ref('monthlyAmount'),
                        'Yearly amount must be larger than the monthly value'
                    ),
            }),
    });

    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    return (
        <FormPage
            title={plan.id ? 'Edit Price Plan' : 'Create Price Plan'}
            loading={loading}
            initialValues={plan}
            canSubmit={!disabled}
            onSubmit={onSubmit}
            onCancel={onCancel}
            onDelete={disabled ? undefined : onDelete}
            deleting={deleting}
            breadcrumbs={breadcrumbs}
            validationSchema={validationSchema}
            render={() => (
                <React.Fragment>
                    <FormSection title="Plan Info">
                        <TextField
                            name="name"
                            required
                            fullWidth
                            id="name"
                            label="Name"
                            margin="normal"
                            disabled={disabled}
                            autoFocus
                        />

                        <Radios
                            disabled={disabled}
                            name="type"
                            label="How is this plan charged?"
                            data={planTypes}
                            radioGroupProps={{
                                style: { margin: 'normal' },
                            }}
                        />
                    </FormSection>

                    <FormCondition when="type" is={value => value !== 'FREE'}>
                        <FormSection title="Pricing">
                            <FormCondition when="type" is="MONTHLY_CHARGE">
                                <Field
                                    disabled={disabled}
                                    required
                                    fullWidth
                                    name="monthlyAmount"
                                    placeholder="$0.00"
                                    label="USD billed every 30 days"
                                    component={DollarFormatInput}
                                />
                            </FormCondition>

                            {/*<FormCondition when="type" is="MONTHLY_CHARGE">
                                <Field
                                    component={SwitchAdapter}
                                    name="discountedYearlyPrice"
                                    label="This plan has a yearly discounted price"
                                />
                            </FormCondition>

                            <FormCondition when="type" is="MONTHLY_CHARGE">
                                <FormCondition when="discountedYearlyPrice" is={true}>
                                    <Field
                                        required
                                        fullWidth
                                        name="yearlyAmount"
                                        placeholder="$0.00"
                                        label="USD billed as one charge per year"
                                        component={DollarFormatInput}
                                    />
                                </FormCondition>
                            </FormCondition>*/}

                            <FormCondition when="type" is="YEARLY_CHARGE">
                                <Field
                                    disabled={disabled}
                                    required
                                    fullWidth
                                    name="yearlyAmount"
                                    placeholder="$0.00"
                                    label="USD billed as one charge per year"
                                    component={DollarFormatInput}
                                />
                            </FormCondition>
                        </FormSection>
                    </FormCondition>
                </React.Fragment>
            )}
        />
    );
}
